(ns practitest.frontend.components2.dashboard.charts.table-chart
  (:require [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.components2.dashboard.charts.protocol :as p]
            [practitest.frontend.components2.dashboard.helpers :as h]
            [practitest.frontend.components2.dashboard.transforms.table :as transforms]
            [practitest.frontend.components2.run-status :as run-status]
            [practitest.frontend.components2.statuses-bar :refer [statuses-bar]]
            [practitest.frontend.components2.tooltip :as t]))

(defmethod p/transform-data ::chart/table [chart]
  (transforms/transform chart))

(defn view [{:chart/keys [data entity-name item-route cell-urls]}]
  (let [{:keys [columns rows table-type]} data
        url         (when (not= table-type "distribution") (h/url-for item-route {}))
        show-link?  (and url (not= entity-name "Instances"))
        col-class   (into {} (map (fn [{:keys [key]}] [key (str "col-" (name key))]) columns))
        render-cell (fn [value]
                      (if (map? value)
                        [statuses-bar (seq value) #(run-status/get-status-color (subs (str %) 1))]
                        (let [text (str value)]
                          [t/tooltip
                           (fn [props] [:span props text])
                           text])))]
    [:div.table-chart-content
     [:div.table-wrapper
      [:table.chart
       [:thead
        [:tr
         (for [{:keys [key label]} columns]
           [:th {:key key :class (col-class key)}
            [t/tooltip
             (fn [props] [:span props label])
             label]])]]
       [:tbody
        (for [[i row] (map-indexed vector rows)]
          [:tr {:key i}
           (for [{:keys [key]} columns]
             (let [cell-url (get cell-urls [i key])]
               [:td {:key key :class (col-class key)}
                (if cell-url
                  [:a {:href cell-url} (render-cell (get row key))]
                  (render-cell (get row key)))]))])]]]
     (when show-link?
       [:a.entities-link {:href url}
        (str (get-translation "dashboards.chart.link.go-to" "Go to ")
             entity-name)])]))